import { computed, inject, Injectable, signal } from "@angular/core";
import { AuthStore } from "../+state/auth";
import { DashboardUrls } from "../constants";
@Injectable({
  providedIn: "root",
})
export class TenantFeatureToggleService {
  readonly #authStore = inject(AuthStore);

  modalHeader = signal<string | null>(null);

  mySubmissionsAccessAndRedirect = computed(() => {
    if (!this.#authStore.memberUser()) {
      return null;
    }

    const orgList: string[] = ["scp"];
    const defaultAccess = {
      allow: true,
      navigateTo: DashboardUrls.Submissions,
    };

    if (orgList.length === 0) {
      return defaultAccess;
    }

    if (this.#authStore.primaryOrganization()?.isSecretariat) {
      const tenant = this.#authStore.tenant()?.toLowerCase() ?? "";
      const allow = !orgList.includes(tenant);

      return {
        allow: allow,
        navigateTo: allow ? DashboardUrls.Submissions : DashboardUrls.Secretariat,
      };
    }

    return defaultAccess;
  });

  upstreamLabel = computed(() => {
    const orgList: string[] = ["gpsnr"];
    const defaultLabel = "Upstream";

    if (orgList.length === 0) {
      return defaultLabel;
    }

    const useCustom = orgList.includes(this.#authStore.tenant()?.toLowerCase() ?? "");

    if (useCustom) {
      return "Supplier";
    }

    return defaultLabel;
  });
}
